import { hasProp, isArray, isNumber, isObject, isString } from "@/utils/matchers";
import { Truck } from "./truck.types";

export type OldTruck = Truck & {
  shaftQuantity: number | null;
  implementType: string | null;
  grossCapacity: string | null;
  netCapacity: string | null;
};

const isTruckV2 = (response: Truck | Truck[]): response is OldTruck => {
  const guard = (obj: any): obj is OldTruck =>
    hasProp(obj, "implementTypeRef", isObject) &&
    hasProp(obj.implementTypeRef, "id", isNumber) &&
    hasProp(obj.implementTypeRef, "name", isString) &&
    hasProp(obj.implementTypeRef, "shaftQuantity", isNumber) &&
    hasProp(obj.implementTypeRef, "grossCapacity", isString) &&
    hasProp(obj.implementTypeRef, "netCapacity", isString);

  if (hasProp(response, "truck", isObject)) {
    return guard(response.truck);
  }

  if (hasProp(response, "data", isArray)) {
    return response.data.some((item: any) => hasProp(item, "truck", isObject) && guard(item.truck));
  }

  return guard(response);
};

export function transformTruckResponse(response: Truck | Truck[]) {
  const isResponseArray = isArray(response);
  const trucks = isResponseArray ? response : [response];

  if (trucks.some(isTruckV2)) {
    if (isResponseArray) {
      return trucks.map((truck) => ({
        ...truck,
        implementType: truck.implementTypeRef?.name || (hasProp(truck, "implementType") ? truck.implementType : null),
        shaftQuantity: truck.implementTypeRef?.shaftQuantity || (hasProp(truck, "shaftQuantity") ? truck.shaftQuantity : null),
        grossCapacity: truck.implementTypeRef?.grossCapacity || (hasProp(truck, "grossCapacity") ? truck.grossCapacity : null),
        netCapacity: truck.implementTypeRef?.netCapacity || (hasProp(truck, "netCapacity") ? truck.netCapacity : null),

        $implementType: truck.implementTypeRef?.name || (hasProp(truck, "implementType") ? truck.implementType : null),
        $shaftQuantity: truck.implementTypeRef?.shaftQuantity || (hasProp(truck, "shaftQuantity") ? truck.shaftQuantity : null),
        $grossCapacity: truck.implementTypeRef?.grossCapacity || (hasProp(truck, "grossCapacity") ? truck.grossCapacity : null),
        $netCapacity: truck.implementTypeRef?.netCapacity || (hasProp(truck, "netCapacity") ? truck.netCapacity : null)
      }));
    }

    return {
      ...response,
      implementType: response.implementTypeRef?.name || (hasProp(response, "implementType") ? response.implementType : null),
      shaftQuantity: response.implementTypeRef?.shaftQuantity || (hasProp(response, "shaftQuantity") ? response.shaftQuantity : null),
      grossCapacity: response.implementTypeRef?.grossCapacity || (hasProp(response, "grossCapacity") ? response.grossCapacity : null),
      netCapacity: response.implementTypeRef?.netCapacity || (hasProp(response, "netCapacity") ? response.netCapacity : null)
    };
  }

  return response;
}
